import { Modal } from "../../../../BP2Components";
import SimpleListTable from "../../../../ListTable/ListTable";

interface ListPreviewProps {
   listId: string;
   isOpen: boolean;
   setIsOpen: (isOpen: boolean) => void;
}

const ListPreviewModal: React.FC<ListPreviewProps> = ({ listId, isOpen, setIsOpen }) => {
   return (
      <Modal height={window?.innerHeight / 0.7} isOpen={isOpen} onCancel={() => setIsOpen(false)}>
         <SimpleListTable listId={listId} />
      </Modal>
   );
};

export default ListPreviewModal;
